module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-x-fill-a5c8879d.svg";